import dayjs from '~/timeInit';

export function getCharterPricingToday(): string {
  return dayjs().tz('Australia/Sydney').format('YYYY-MM-DD');
}

export function canEditCharterPricingDeparture(departureDate: string): boolean {
  const date = dayjs(departureDate, 'DD/MM/YYYY', true);
  return date.isValid() && date.format('YYYY-MM-DD') >= getCharterPricingToday();
}
